
import { combineReducers } from 'redux';
import { dataReducer } from './Reducer';

const rootReducer = combineReducers({
    data: dataReducer
  // Add other reducers here if needed
});

export default rootReducer;